import { render, staticRenderFns } from "./saldotabungan.vue?vue&type=template&id=e64a5470&scoped=true"
import script from "./saldotabungan.vue?vue&type=script&lang=js"
export * from "./saldotabungan.vue?vue&type=script&lang=js"
import style0 from "./saldotabungan.vue?vue&type=style&index=0&id=e64a5470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64a5470",
  null
  
)

export default component.exports